export default "__VITE_ASSET__D9lYm6_1__"